import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BaasicButton, BaasicFieldDropdown } from 'core/components';

function OrderingDoctorEditModalTemplate({ orderingDoctorEditModalViewStore, t }) {
    const {
        form,
        modalParams,
        doctorStore
    } = orderingDoctorEditModalViewStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Edit Ordering Doctor</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BaasicFieldDropdown field={form.$('orderingDoctorId')} store={doctorStore} />
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicFormControls
                    form={form}
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating}
                    label="Submit"
                    className='btn btn--med btn--primary'
                />
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
            </div>
        </section>
    )
}

OrderingDoctorEditModalTemplate.propTypes = {
    orderingDoctorEditModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(OrderingDoctorEditModalTemplate);
